module.exports = __webpack_public_path__ + "static/fonts/Gotham-Book.eca1317.otf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Gotham-Book.otf
// module id = zE/z
// module chunks = 1